import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class PasswordChangeForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'password',
			value => {
				return value.trim().match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(^.{12,}$)/);
			},
			'PASSWORDMINREQUIREMENTS'
		);
		return {
			fields: [
				{
					name: 'oldPassword',
					label: 'LOGINFORM.OLDPASSWORD',
					rules: 'required|string',
					type: 'password',
				},
				{
					name: 'newPassword',
					label: 'LOGINFORM.NEWPASSWORD',
					rules: 'required|string|different:oldPassword|password',
					type: 'password',
				},
				{
					name: 'newPasswordConfirm',
					label: 'LOGINFORM.NEWPASSWORDCONFIRM',
					rules: 'required|string|same:newPassword|password',
					type: 'password',
				},
			],
		};
	}
}
